<template>
  <section
    class="container mx-auto px-4 mt-10 mb-8 text-azul-profundo"
    :aria-label="$t('vitrine.maps.aria')"
  >
    <h2 class="text-2xl font-bold">
      {{ $t("vitrine.maps.title") }}
    </h2>

    <address class="not-italic mt-1 text-sm text-cinza-700">
      {{ $t("vitrine.maps.addrLine1") }}<br />
      {{ $t("vitrine.maps.addrLine2") }}
    </address>

    <div class="mt-4 rounded overflow-hidden shadow">
      <iframe
        :src="mapSrc"
        class="w-full aspect-video border-0"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        allowfullscreen
        :aria-label="$t('vitrine.maps.ariaMap')"
      ></iframe>
    </div>
  </section>
</template>

<script setup>
// Mantemos a URL do Google Maps (idioma do embed pode ser ajustado
// depois, se necessário, sem impactar i18n do app).
const mapSrc =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6298.158331792051" +
  "!2d8.757135212534164!3d50.79614016229455!2m3!1f0!2f0!3f0!3m2!1i1024!" +
  "2i768!4f13.1!3m3!1m2!1s0x47bc626fcec593a7%3A0x48bf8be1345e6915!2s" +
  "Gisselberger%20Str.%2033%2C%2035037%20Marburg!5e1!3m2!1spt-BR!2sde!" +
  "4v1756624950853!5m2!1spt-BR!2sde";
</script>
